document.addEventListener('DOMContentLoaded', function () {
    // Desktop Dropdowns
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

    dropdownToggles.forEach((toggle) => {
        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            const parent = this.parentElement;
            const isOpen = parent.classList.contains('show');

            // Close all other dropdowns
            document.querySelectorAll('.dropdown').forEach((d) => {
                d.classList.remove('show');
                d.querySelector('.dropdown-toggle').setAttribute('aria-expanded', 'false');
            });

            if (!isOpen) {
                parent.classList.add('show');
                this.setAttribute('aria-expanded', 'true');
            }
        });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function (e) {
        if (!e.target.closest('.dropdown')) {
            document.querySelectorAll('.dropdown').forEach((d) => {
                d.classList.remove('show');
                const toggle = d.querySelector('.dropdown-toggle');
                if (toggle) toggle.setAttribute('aria-expanded', 'false');
            });
        }
    });

    // Mobile Offcanvas — IDs renderizados pelo snippet purple-menu-header.liquid
    const mobileToggle = document.getElementById('mobile-menu-toggle');
    const mobileClose = document.getElementById('purpleOffcanvasClose');
    const offcanvas = document.getElementById('purpleOffcanvas');
    const backdrop = document.getElementById('purpleOffcanvasBackdrop');

    function openMenu() {
        if (!offcanvas || !backdrop) return;
        offcanvas.classList.add('show');
        backdrop.classList.add('show');
        document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
        if (!offcanvas || !backdrop) return;
        offcanvas.classList.remove('show');
        backdrop.classList.remove('show');
        document.body.style.overflow = '';
    }

    if (mobileToggle) mobileToggle.addEventListener('click', openMenu);
    if (mobileClose) mobileClose.addEventListener('click', closeMenu);
    if (backdrop) backdrop.addEventListener('click', closeMenu);

    // Mobile Search Bar Toggle
    const searchTrigger = document.getElementById('mobile-search-trigger');
    const searchBar = document.getElementById('mobile-search-bar');
    if (searchTrigger && searchBar) {
        searchTrigger.addEventListener('click', function (e) {
            e.preventDefault();
            searchBar.classList.toggle('active');
            searchTrigger.classList.toggle('active');
            if (searchBar.classList.contains('active')) {
                const input = searchBar.querySelector('input');
                if (input) input.focus();
            }
        });
    }
});